import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/expand_less.svg?url_encode")